export const INCIDENT_EPISODE_TYPE = {
    wc: 1,
    auto: 2,
    accessAssistance: 4, // TryStar MAA/MPN
    liability: 5,
    nonRevenue: 6, 
    highProfileLiability: 9,
    property: 10,
    workplaceViolence: 11,
    messageCenter: 12,
    linDirect: 13,
    healthcare: 15,
    drugTesting: 16,
    crisis: 17,
    theftAwareness: 19
};

export const INCIDENT_BODY_PART = {
    10: 'Abdomen',
    15: 'Abdomen Lower',
    20: 'Abdomen Upper',
    25: 'Ankle',
    30: 'Arm',
    40: 'Arm Lower',
    35: 'Arm Upper',
    65: 'Back',
    45: 'Back All',
    50: 'Back Lower',
    55: 'Back Middle',
    60: 'Back Upper',
    70: 'Breast',
    75: 'Buttocks',
    80: 'Cheek',
    85: 'Chest',
    90: 'Chin',
    95: 'Collar Bone Clavicle',
    100: 'Ear',
    105: 'Elbow',
    115: 'Eye',
    110: 'Eye Brow',
    117: 'Eyelid',
    120: 'Face Soft Tissues',
    125: 'Facial Bones',
    130: 'Finger Index',
    135: 'Finger Middle',
    140: 'Finger Pinky',
    145: 'Finger Ring',
    155: 'Fingers',
    160: 'Foot',
    165: 'Forehead',
    170: 'Genital(s)',
    175: 'Groin',
    180: 'Hand',
    185: 'Head',
    190: 'Heel',
    195: 'Hip',
    200: 'Jaw',
    205: 'Knee',
    210: 'Leg',
    215: 'Leg Calf',
    220: 'Leg Lower',
    225: 'Leg Shin',
    230: 'Leg Upper',
    235: 'Lip Lower',
    240: 'Lip Upper',
    245: 'Lips',
    250: 'Lungs (breathing, inhalation)',
    255: 'Mouth',
    260: 'Mouth Lower',
    265: 'Mouth Upper',
    275: 'Neck Non-Tissue',
    270: 'Neck Soft Tissue',
    280: 'No Physical Injury',
    285: 'Nose',
    5: 'Not Applicable',
    290: 'Rib(s)',
    295: 'Scalp',
    300: 'Shoulder',
    305: 'Tailbone (Sacrum/Coccyx)',
    320: 'Teeth',
    310: 'Teeth Lower',
    315: 'Teeth Upper',
    325: 'Throat',
    330: 'Thumb',
    335: 'Toe(s)',
    340: 'Tongue',
    345: 'Unclassified',
    350: 'Unknown',
    355: 'Wrist'
};

export const INCIDENT_DISPOSITION = [
    'Incomplete',
    'Triage',
    'Triage (Referred)',
    'Report Only',
    'Report Only (Referred)'
];

export const INCIDENT_IS_TRIAGED = {
    1: 'Triage',
    0: 'No Triage'
};

export const INCIDENT_LEVEL_OF_CARE = [
    'ER',
    'Non-ER',
    'Telemed',
    'Self-Care',
    'Untreated'
];

export const INCIDENT_MAIN_COMPLAINT = {
    1: 'Airborne Exposure',
    28: 'Allergic Reaction',
    2: 'Animal Bite or Scratch',
    3: 'Back Pain',
    4: 'Body Fluid Exposure',
    5: 'Bruises, Contusions, Other Blunt Injuries',
    6: 'Burn - Thermal and Chemical',
    7: 'Chest Pain',
    13: 'Closed Head Injury',
    31: 'COVID-19',
    8: 'Cuts, Lacerations, Scrapes, Punctures',
    29: 'Death',
    9: 'Dental Injury',
    10: 'Electrical Shock',
    11: 'Eye Injuries',
    30: 'Eye Loss',
    14: 'Hearing - Loss, Ringing, Pain',
    15: 'Heat Stress/Exhaustion',
    16: 'Human Bites',
    18: 'Inhalation',
    19: 'Insect, Spider, and Tick Bites',
    33: 'Motor Vehicle Accident',
    21: 'No Physical Injury',
    22: 'Repetitive Motion Symptoms',
    23: 'Skin Irritation OR Rash',
    24: 'Sprain, Strain, Twist',
    17: 'Stings',
    25: 'Stress, Anxiety, Depression',
    26: 'Unclassified',
    27: 'Unknown',
    32: 'Vaccination Reaction',
};

export const INCIDENT_SEVERITY_LEVEL = {
    // 1: 'Initial Assessment',
    2: 'Call 911',
    // 3: 'Go to ED',
    // 4: 'Call Poison Center',
    5: 'Emergent Care Referral',
    6: 'Referred within 4 hours',
    7: 'Referred within 24 hours',
    8: 'Referred within 72 hours',
    // 9: 'Call Local Agency',
    10: 'Self-Care',
};

export const INCIDENT_NOTIFIED_FLAG = {
    1: 'Yes',
    2: 'No',
    3: 'N/A',
    '[REF]': 'Refused',
    '[UNK]': 'Unknown'
};

export const INCIDENT_STATES = {
    INTAKE: 1,
    NO_TRIAGE: 2,
    TRIAGE: 3,
    VOID: 4,
    DONE: 5,
    AUTOMATICALLY: 6,
    ABANDONED: 7
};

export const DISTRIBUTION_STATUS = {
    ERROR: -1,
    PENDING: 0,
    PROCESSING: 1,
    DONE: 2,
    OUTSIDE_BUSINESS_HOURS: 3
};

export const ORIGIN = {
    LAX_IVR: 'Phone Call',
    LIN_IVR: 'Lin - IVR Deflection',
    LIN_QR: 'Lin - QR Code',
    LIN_WIDGET: 'Lin - Webpage',
    SMS: 'SMS',
    MOBOTORY: 'Mobotory',
    BAMTECH_EMAIL: 'Email'
};
